import xws from 'api/xws/';
import qs from 'query-string';
import {
  ERROR_REPAIR,
  ERROR_MAINTENANCE
} from 'store/reducers/errors/actionTypes';

// Actions
import { getMetaVehicleId } from 'store/reducers/appointment/actions';
import { ajaxCallbacks } from 'store/reducers/ajaxCall/actions';
import {
  setSabService,
  setServiceCategories
} from 'store/reducers/deeplink/actions';

// Selectors
import {
  getVariant,
  getMileageUnit
} from 'store/reducers/dealerSettings/selectors';
import { getWebkey } from 'store/reducers/queryParams/selectors';
import { getLocaleCode } from 'store/reducers/dealerLocale/selectors';

// Constants
import { getService } from 'constants/ajax';

export const getIndividualServices = (serviceId, dispatchType) => async (
  dispatch,
  getState
) => {
  const {
    appointment: { vehicle }
  } = getState();
  try {
    if (!vehicle.metaVehicleId) {
      await dispatch(getMetaVehicleId(vehicle));
    }
    const {
      tokenId,
      appointment: {
        vehicle: { make, year, model, ...vehicleInfo }
      }
    } = getState();
    const service = getService(serviceId);
    const webkey = getWebkey(getState());
    service.setPathVars({ webkey, make, year, model });
    service.setCallBacks(dispatch(ajaxCallbacks()));
    const {
      data: { services }
    } = await xws(service).post(
      service.getPath(),
      qs.stringify({
        ...vehicleInfo,
        make,
        locale: getLocaleCode(getState()),
        authId: tokenId,
        variant: getVariant(getState()),
        units: getMileageUnit(getState())
      })
    );
    await dispatch({
      type: dispatchType,
      payload: services
    });
    await dispatch(setSabService(services));
    await dispatch(setServiceCategories(services));
  } catch (e) {
    /* eslint-disable no-console */
    if (serviceId === 'repair') {
      dispatch({
        type: ERROR_REPAIR,
        payload: true
      });
    } else {
      dispatch({
        type: ERROR_MAINTENANCE,
        payload: true
      });
    }
    console.error(e);
    /* eslint-enable no-console */
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/individualServices/actions.js